export default {"src":"/_next/static/media/logoHeaderAbout.811fb53e.svg","height":307,"width":126,"blurWidth":0,"blurHeight":0};